export default "__VITE_ASSET__DZf5KxV2__"